/**
 * Nested-safe body scroll lock for overlays (walkthrough, mobile nav, filters, modals).
 * Nested open/close must not leave {@code document.body.style.overflow} stuck on {@code hidden}.
 */
let lockCount = 0;

export function lockBodyScroll() {
    if (typeof document === "undefined") {
        return;
    }
    if (lockCount === 0) {
        document.body.style.overflow = "hidden";
    }
    lockCount += 1;
}

export function unlockBodyScroll() {
    if (typeof document === "undefined") {
        return;
    }
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
        document.body.style.overflow = "";
    }
}
